import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CanceledOrderMiniModel } from './CanceledOrderMiniModel'
import type {
  CanceledOrderAdminListedDtoAdmin,
  Pagination1OfCanceledOrderAdminListedDto
} from '@/backend/market'
import { CanceledOrderResponseEntity } from '../../domain/entities/CanceledOrderResponseEntity'

export class CanceledOrderResponseModel extends CanceledOrderResponseEntity {
  constructor(dataDto: Pagination1OfCanceledOrderAdminListedDto) {
    super()
    const canceledOrderMiniModel = dataDto.items?.map(
      (item: CanceledOrderAdminListedDtoAdmin) => new CanceledOrderMiniModel(item)
    )
    mapEntityProperties<CanceledOrderResponseEntity>(this, dataDto, {
      map: {
        items: canceledOrderMiniModel
      }
    })
  }
}
